import React from 'react';

import UpiLogo from 'assets/images/pages/plans/UPI.png';

import classes from './upiBadge.module.scss';

const UpiBadge = () => {
    return (
        <div className={classes['upi-badge']}>
            <span className={classes['label']}>Pay with</span>
            <img className={classes['logo']} src={UpiLogo.src} alt='UPI' />
        </div>
    );
};

export default UpiBadge;
